var render = function render(){var _vm=this,_c=_vm._self._c;return _c('new-button',{staticClass:"truncate w-full",class:_vm.className,attrs:{"size":_vm.size,"type":_vm.buttonConfig.type,"disabled":_vm.shouldDisable},on:{"click":_vm.checkout}},[_vm._v(_vm._s(_vm.buttonConfig.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }